@import 'src/styles/common/_colors.scss';

.errorMessageBody {
    height: 170px;
    padding: 0px 10px;
    p {
        margin: 10px 0 !important;
    }
}
.errorPopupFooter {
    padding: 5px;
}